
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Shadow04:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M127.912 114.072C124.424 125.822 84.4517 115.983 52.8291 118.779C14.1644 122.212 -1.26129 112.444 0.080072 108.162C6.2168 88.4137 23.9899 108.056 54.0699 96.3413C117.919 71.426 129.153 109.861 127.912 114.072Z" fill="#0C0D0D"/>
</svg>

  }
  
